import { useEffect } from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';

/**
 * Globaler Scroll-Reset bei Routenwechsel.
 *
 * - Bei PUSH/REPLACE (z. B. Klick auf eine Detailseite, neuer Link, Redirect)
 *   wird wie bisher an den Seitenanfang gescrollt.
 * - Bei POP (Browser-Back/Forward) wird NICHT zurückgesetzt. Das gibt der
 *   `useScrollRestoration`-Logik in den Listenansichten die Möglichkeit, die
 *   zuletzt gespeicherte Scrollposition wiederherzustellen, sobald die Daten
 *   gerendert sind. So bleibt beim Zurücknavigieren von einer Detailseite
 *   die Position des zuletzt geöffneten Listenelements im sichtbaren Bereich.
 */
const ScrollToTop = ({ history }: RouteComponentProps): JSX.Element | null => {
    useEffect(() => {
        const unlisten = history.listen((_location, action) => {
            if (action === 'POP') {
                return;
            }
            // Erst nach Ende der synchronen History-Callbacks ausführen, damit andere
            // Listener (z. B. useScrollRestoration) noch window.scrollY der Liste lesen
            // und speichern können, bevor wir auf Y=0 springen.
            Promise.resolve().then(() => {
                window.scrollTo(0, 0);
            });
        });
        return (): void => {
            unlisten();
        };
    }, [history]);

    return null;
};

export default withRouter(ScrollToTop);
